import { createAction } from "@reduxjs/toolkit";

export const apiCall = createAction<any>("api/Call");
export const apiCallSuccess = createAction<any>("api/CallSuccess");
export const apiCallFailed = createAction<any>("api/CallFailed");
